import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FolderViewModel } from '@ca/core/models';
import { FileExplorerHistoryService } from '../../services/file-explorer-history.service';

@Component({
    selector: 'ca-file-explorer-breadcrumb',
    templateUrl: './file-explorer-breadcrumb.component.html',
    styleUrls: ['./file-explorer-breadcrumb.component.scss'],
})
export class FileExplorerBreadcrumbComponent {
    @Input() rootTitle?: string;

    @Input() hideStaticHome = false;

    @Output() onClickOnHome = new EventEmitter<void>();
    @Output() onClickOnBreadcrumbItem = new EventEmitter<FolderViewModel>();
    @Output() navigate: EventEmitter<FolderViewModel | undefined> = new EventEmitter<FolderViewModel | undefined>();

    get history(): FolderViewModel[] {
        return this.fileExplorerHistoryService.getHistory();
    }

    constructor(private fileExplorerHistoryService: FileExplorerHistoryService) {}

    clickOnBreadcrumbItem(folder: FolderViewModel): void {
        this.onClickOnBreadcrumbItem.emit(folder);
    }

    clickOnHome(): void {
        this.onClickOnHome.emit();
    }

    onNavigate(folder: FolderViewModel, index: number): void {
        this.onClickOnBreadcrumbItem.emit(folder);
        this.navigate.emit({
            ...folder,
            indexInBreadcrumb: index,
        });
    }
}
